import React from "react";
import {planCarLogo} from "@img/index.js";

// "Lock in your return ride" copy — shared by the desktop tooltip in DestinationBanner
// (.hopn-submit-confirm-tooltip) and the mobile modal (.return-trip-info).
export function ReturnTripInfoContent() {
    return (
        <>
            <h6>Lock in your return ride – 25% off</h6>
            <img src={planCarLogo} alt="Info"/>
            <p>After completing this booking, you will receive a pop-up/email with your return booking link</p>
        </>
    );
}

export default ReturnTripInfoContent;
